import axios from "axios";

const envBase = process.env.REACT_APP_BACKEND_URL?.trim();
const browserOrigin = typeof window !== "undefined" ? window.location.origin : "";

function resolveBaseUrl() {
  if (!envBase) return browserOrigin;

  try {
    const envUrl = new URL(envBase);
    const pageUrl = browserOrigin ? new URL(browserOrigin) : null;

    // Prevent mixed-content failures when the app is served over HTTPS.
    if (pageUrl && pageUrl.protocol === "https:" && envUrl.protocol === "http:") {
      return browserOrigin;
    }
  } catch {
    return envBase;
  }

  return envBase;
}

const BASE = resolveBaseUrl();

export const API_BASE = `${BASE}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Helper: extract error message from FastAPI's `detail` (may be string or array)
export function formatApiError(err, fallback = "Что-то пошло не так") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatPrice(n) {
  if (n === null || n === undefined) return "";
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 0,
  }).format(n);
}

// Resolve image URLs: prepend backend host for relative /api/uploads paths.
export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BASE}${url}`;
  return url;
}
